import HttpClienteToken from '../../services/HttpClientToken';

import { SexoProps } from '../../interfaces/catalogos/SexoInterface';

export const Sexo = () => {

    return new Promise<SexoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Sexo/', token)
            .then( ({ data } : { data : SexoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerSexo = () => {

    return new Promise<SexoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Sexo/ObtenerSexo', token)
            .then( ({ data } : { data : SexoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarSexo = ( params: SexoProps ) => {

    return new Promise<SexoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Sexo/Actualizar', params, token)
            .then( ({ data } : { data : SexoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idSexo: 0,                 
                    descripcion: '',
                    activo: false,    
                    abreviacion: "" 
                });
            });
        }

    });

}

export const AgregarSexo = ( params: SexoProps ) => {

    return new Promise<SexoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Sexo/Agregar', params, token)
            .then( ({ data } : { data : SexoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idSexo: 0,                   
                    descripcion: '',
                    activo: false,    
                    abreviacion: "" 
                });
            });
        }

    });

}